/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channel_Push_OnlyInputs */

const th_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะพุช`)
};

const en_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push only`)
};

const ja_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュのみ`)
};

const zh_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅推送`)
};

const es_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo notificaciones push`)
};

const pt_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente push`)
};

const id_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push saja`)
};

const fr_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push uniquement`)
};

const tl_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push lamang`)
};

const vi_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ đẩy`)
};

const ko_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시만`)
};

const de_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Push`)
};

const ru_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только push`)
};

const tr_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca anlık bildirim`)
};

const it_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo notifiche push`)
};

const pl_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko powiadomienia push`)
};

const uk_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лише push`)
};

const hi_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल पुश`)
};

const ar_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات الفورية فقط`)
};

const ms_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak sahaja`)
};

const bn_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুধু পুশ`)
};

const zh_tw2_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅推播`)
};

const zh_hk2_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅推播`)
};

const ur_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صرف پُش`)
};

const fa_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فقط اعلان فوری`)
};

const sw_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa za papo hapo pekee`)
};

const nl_channel_push_only = /** @type {(inputs: Channel_Push_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen push`)
};

/**
* | output |
* | --- |
* | "Push only" |
*
* @param {Channel_Push_OnlyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const channel_push_only = /** @type {((inputs?: Channel_Push_OnlyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channel_Push_OnlyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_channel_push_only(inputs)
	if (locale === "ja") return ja_channel_push_only(inputs)
	if (locale === "zh") return zh_channel_push_only(inputs)
	if (locale === "es") return es_channel_push_only(inputs)
	if (locale === "pt") return pt_channel_push_only(inputs)
	if (locale === "id") return id_channel_push_only(inputs)
	if (locale === "fr") return fr_channel_push_only(inputs)
	if (locale === "tl") return tl_channel_push_only(inputs)
	if (locale === "vi") return vi_channel_push_only(inputs)
	if (locale === "ko") return ko_channel_push_only(inputs)
	if (locale === "de") return de_channel_push_only(inputs)
	if (locale === "ru") return ru_channel_push_only(inputs)
	if (locale === "tr") return tr_channel_push_only(inputs)
	if (locale === "it") return it_channel_push_only(inputs)
	if (locale === "pl") return pl_channel_push_only(inputs)
	if (locale === "uk") return uk_channel_push_only(inputs)
	if (locale === "hi") return hi_channel_push_only(inputs)
	if (locale === "ar") return ar_channel_push_only(inputs)
	if (locale === "ms") return ms_channel_push_only(inputs)
	if (locale === "bn") return bn_channel_push_only(inputs)
	if (locale === "zh-TW") return zh_tw2_channel_push_only(inputs)
	if (locale === "zh-HK") return zh_hk2_channel_push_only(inputs)
	if (locale === "ur") return ur_channel_push_only(inputs)
	if (locale === "fa") return fa_channel_push_only(inputs)
	if (locale === "sw") return sw_channel_push_only(inputs)
	if (locale === "nl") return nl_channel_push_only(inputs)
	return en_channel_push_only(inputs)
});